var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.718,49.602c0.258-0.82,0.017-1.709-0.569-2.257c-0.516-0.622-2.181-4.091-3.502-7.102 c-0.229-10.216-8.61-18.456-18.88-18.456c-10.413,0-18.885,8.472-18.885,18.885c0,2.815,0.736,6.34,1.587,10.422 c1.143,5.476,2.438,11.683,2.067,17.145c-0.075,1.103,0.758,2.057,1.86,2.131c1.101,0.091,2.056-0.758,2.131-1.859 c0.408-6.013-0.947-12.505-2.143-18.233c-0.773-3.704-1.503-7.203-1.503-9.605c0-8.208,6.677-14.885,14.885-14.885 s14.885,6.677,14.885,14.885c0,0.274,0.057,0.546,0.166,0.797c0.962,2.213,2.133,4.785,3.119,6.597 c-0.72,0.169-1.589,0.339-2.416,0.463c-1.02,0.153-1.757,1.056-1.701,2.085l0.245,4.568l-1.405,2.705 c-0.148,0.284-0.226,0.601-0.226,0.922v2.58h-7.909c-0.562,0-1.098,0.236-1.477,0.651s-0.566,0.971-0.515,1.53l0.517,5.671 c0.095,1.038,0.967,1.818,1.989,1.818c0.061,0,0.122-0.003,0.184-0.008c1.1-0.101,1.91-1.073,1.81-2.174l-0.318-3.489h7.719 c1.104,0,2-0.896,2-2v-4.092l1.432-2.756c0.165-0.316,0.242-0.672,0.223-1.029l-0.179-3.337 C60.176,51.329,60.497,50.306,60.718,49.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.672,55.239c0.312,0.781,1.063,1.258,1.857,1.258c0.247,0,0.498-0.047,0.742-0.144l5.891-2.357 c1.025-0.41,1.524-1.573,1.113-2.6c-0.409-1.024-1.569-1.523-2.6-1.113l-5.891,2.355C60.76,53.05,60.261,54.213,60.672,55.239z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.418,58.143l-5.806-0.384c-1.112-0.069-2.055,0.762-2.128,1.864c-0.072,1.103,0.762,2.055,1.864,2.128l5.806,0.384 c0.045,0.003,0.09,0.004,0.134,0.004c1.044,0,1.924-0.811,1.994-1.868C71.354,59.168,70.521,58.216,69.418,58.143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.474,65.394l-4.024-2.324c-0.958-0.557-2.181-0.226-2.731,0.731c-0.553,0.956-0.226,2.18,0.731,2.731l4.024,2.324 c0.314,0.183,0.659,0.269,0.998,0.269c0.691,0,1.363-0.358,1.733-1C67.758,67.169,67.431,65.945,66.474,65.394z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCough);
export default __webpack_public_path__ + "static/media/cough.35e4d1ccf6533db39b4672f3f8329cd9.svg";
export { ForwardRef as ReactComponent };